"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpeechToText = useSpeechToText;
var _react = require("react");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Ported from lobees-web's helper/ConversationHelper/ConversationHelper.js,
// which was already a pure, framework-agnostic module — this hook just owns
// the refs/state that file expected its caller to manage, so consuming
// components no longer juggle recognitionRef/manualListeningRef themselves.
function initSpeechRecognition(language) {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) return null;
  const recognition = new SpeechRecognition();
  recognition.continuous = true;
  recognition.interimResults = true;
  recognition.lang = language === "es" ? "es-ES" : "en-US";
  return recognition;
}
function useSpeechToText() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? "en" : _ref$language,
    onFinalTranscript = _ref.onFinalTranscript;
  const recognitionRef = (0, _react.useRef)(null);
  const manualListeningRef = (0, _react.useRef)(false);
  const _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isListening = _useState2[0],
    setIsListening = _useState2[1];
  const _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    interimTranscript = _useState4[0],
    setInterimTranscript = _useState4[1];
  const isSupported = typeof window !== "undefined" && !!(window.SpeechRecognition || window.webkitSpeechRecognition);
  const teardown = (0, _react.useCallback)(() => {
    manualListeningRef.current = false;
    try {
      var _recognitionRef$curre;
      (_recognitionRef$curre = recognitionRef.current) === null || _recognitionRef$curre === void 0 || _recognitionRef$curre.stop();
    } catch (e) {
      // ignore — stop() on an already-stopped recognizer throws in some browsers
    }
    recognitionRef.current = null;
    setIsListening(false);
    setInterimTranscript("");
  }, []);

  // Recognition instances are bound to a language at construction time, so a
  // language change resets and lazily re-creates on the next start().
  (0, _react.useEffect)(() => {
    teardown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  (0, _react.useEffect)(() => teardown, [teardown]);
  const start = (0, _react.useCallback)(() => {
    if (!isSupported) return false;
    if (!recognitionRef.current) {
      recognitionRef.current = initSpeechRecognition(language);
    }
    const recognition = recognitionRef.current;
    if (!recognition) return false;
    recognition.onstart = () => setIsListening(true);
    recognition.onresult = event => {
      let finalTranscript = "";
      let interim = "";
      for (let i = event.resultIndex; i < event.results.length; i += 1) {
        const text = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          finalTranscript += text;
        } else {
          interim += text;
        }
      }
      if (interim) setInterimTranscript(interim);
      if (finalTranscript) {
        setInterimTranscript("");
        onFinalTranscript === null || onFinalTranscript === void 0 || onFinalTranscript(finalTranscript.trim());
      }
    };
    recognition.onend = () => {
      if (manualListeningRef.current) {
        try {
          recognition.start();
        } catch (e) {
          setTimeout(() => {
            try {
              recognition.start();
            } catch (err) {
              // give up silently — user can tap the mic again
            }
          }, 250);
        }
      } else {
        setIsListening(false);
      }
    };
    recognition.onerror = event => {
      if ((event === null || event === void 0 ? void 0 : event.error) === "not-allowed" || (event === null || event === void 0 ? void 0 : event.error) === "service-not-allowed") {
        manualListeningRef.current = false;
        setIsListening(false);
      }
    };
    manualListeningRef.current = true;
    try {
      recognition.start();
      return true;
    } catch (e) {
      return false;
    }
  }, [isSupported, language, onFinalTranscript]);
  const stop = (0, _react.useCallback)(() => {
    manualListeningRef.current = false;
    try {
      var _recognitionRef$curre2;
      (_recognitionRef$curre2 = recognitionRef.current) === null || _recognitionRef$curre2 === void 0 || _recognitionRef$curre2.stop();
    } catch (e) {
      // ignore
    }
    setIsListening(false);
    setInterimTranscript("");
  }, []);
  const toggle = (0, _react.useCallback)(() => {
    if (isListening) stop();else start();
  }, [isListening, start, stop]);
  return {
    isSupported,
    isListening,
    interimTranscript,
    start,
    stop,
    toggle
  };
}